
                    module.exports = {"name":"logo","data":{"width":"97","height":"96","viewBox":"0 0 97 96","data":"<path pid=\"0\" d=\"M87.598 37.3l-40.73 40.73L9.533 40.693l18.668-18.668 18.667 18.668L68.93 18.632\" _stroke=\"currentColor\" stroke-width=\"10\"/>"}}
            